<template>
  <div>
    <div class="content-panel">
      <!-- ===== 筛选条件 ===== -->
      <div class="filter-bar">
        <div class="filter-group">
          <label class="filter-label">{{ $t("productServer.region") }}</label>
          <select
            v-model="filters.region"
            class="filter-select"
            @change="handleFilterChange"
          >
            <option value="">{{ $t("productServer.allRegion") }}</option>
            <option
              v-for="country in countryList"
              :key="country.id"
              :value="country.id"
            >
              {{ country.name }}
            </option>
          </select>
        </div>

        <div class="filter-group">
          <label class="filter-label">{{ $t("productServer.status") }}</label>
          <select
            v-model="filters.status"
            class="filter-select"
            @change="handleFilterChange"
          >
            <option value="">{{ $t("productServer.allStatus") }}</option>
            <option value="1">{{ $t("productServer.statusActive") }}</option>
            <option value="2">{{ $t("productServer.statusCompleted") }}</option>
            <option value="3">{{ $t("productServer.statusFrozen") }}</option>
          </select>
        </div>

        <button class="btn-reset" @click="resetFilters">
          {{ $t("productServer.reset") }}
        </button>
      </div>

      <!-- ===== 表格 ===== -->
      <div class="product-table-wrap">
        <!-- 加载状态 -->
        <div v-if="loading" class="loading-state">
          <span class="loading-spinner"></span>
          <p>{{ $t("productServer.loading") }}</p>
        </div>

        <!-- 空状态 -->
        <div v-else-if="productList.length === 0" class="empty-state">
          <span class="empty-icon">📭</span>
          <p>{{ $t("productServer.empty") }}</p>
        </div>

        <!-- 表格 -->
        <table v-else class="product-table">
          <thead>
            <tr>
              <th style="width: 100px">{{ $t("productServer.region") }}</th>
              <th style="width: 100px">
                {{ $t("productServer.productName") }}
              </th>
              <th style="width: 100px">{{ $t("productServer.share") }}</th>
              <!-- <th>本金</th> -->
              <th style="width: 100px">{{ $t("productServer.countdown") }}</th>
              <!-- <th>最新价格</th> -->
              <!-- <th>预估总盈亏</th> -->
              <th style="width: 100px">
                {{ $t("productServer.unsettledIncome") }}
              </th>
              <th style="width: 100px">{{ $t("productServer.settled") }}</th>
              <th style="width: 100px">
                {{ $t("productServer.totalIncome") }}
              </th>
              <th style="width: 100px">{{ $t("productServer.status") }}</th>
              <th style="width: 80px">{{ $t("productServer.action") }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in productList" :key="item.code || index">
              <td>
                <div class="region-cell">
                  <img
                    v-if="item.country_img"
                    :src="item.country_img"
                    :alt="item.country_name"
                    class="region-flag-img"
                    @error="handleImageError"
                  />
                  <span class="region-name">
                    {{ $t("country." + item.country_id) }}
                  </span>
                </div>
              </td>
              <td>
                {{ $t(item.server_code + ".s_model") }}
              </td>
              <td>{{ item.share * 100 }}%</td>
              <!-- <td>${{ formatNumber(item.total) }}</td> -->
              <td>{{ item.end_day }}{{ $t("productServer.day") }}</td>
              <!-- <td>${{ formatNumber(item?.token_price?.price) }}</td> -->
              <!-- <td :class="getRevenueClass(item?.estimated_total_revenue)">
                ${{ formatNumber(item?.estimated_total_revenue) }}
              </td> -->
              <!-- 未结算盈亏 -->
              <td :class="getRevenueClass(item?.current_income)">
                ${{ formatNumber(item?.current_income + item.income) }}
              </td>
              <td class="text-success">
                ${{ formatNumber(item.total_income || 0) }}
              </td>
              <td class="text-success">
                ${{
                  formatNumber(
                    item?.total_income + item?.current_income + item.income ||
                      0,
                  )
                }}
              </td>
              <td>
                <span class="status-badge" :class="getStatusClass(item)">
                  {{ getStatusText(item) }}
                </span>
              </td>
              <td>
                <button class="btn-view" @click="openDetailModal(item)">
                  {{ $t("productServer.view") }}
                </button>
              </td>
            </tr>
          </tbody>
        </table>

        <!-- ===== 分页 ===== -->
        <div v-if="total > 0" class="pagination-wrap">
          <div class="pagination-info">
            {{
              $t("productServer.paginationInfo", {
                total,
                page,
                totalPages,
              })
            }}
          </div>
          <div class="pagination-buttons">
            <button
              class="page-btn"
              :disabled="page <= 1"
              @click="changePage(1)"
            >
              {{ $t("productServer.firstPage") }}
            </button>
            <button
              class="page-btn"
              :disabled="page <= 1"
              @click="changePage(page - 1)"
            >
              {{ $t("productServer.prevPage") }}
            </button>

            <button
              v-for="p in pageNumbers"
              :key="p"
              class="page-btn"
              :class="{ active: p === page }"
              @click="changePage(p)"
            >
              {{ p }}
            </button>

            <button
              class="page-btn"
              :disabled="page >= totalPages"
              @click="changePage(page + 1)"
            >
              {{ $t("productServer.nextPage") }}
            </button>
            <button
              class="page-btn"
              :disabled="page >= totalPages"
              @click="changePage(totalPages)"
            >
              {{ $t("productServer.lastPage") }}
            </button>
          </div>
          <div class="pagination-size">
            <select
              v-model="size"
              @change="handleSizeChange"
              class="size-select"
            >
              <option :value="10">
                {{ $t("productServer.perPage", { count: 10 }) }}
              </option>
              <option :value="20">
                {{ $t("productServer.perPage", { count: 20 }) }}
              </option>
              <option :value="50">
                {{ $t("productServer.perPage", { count: 50 }) }}
              </option>
              <option :value="100">
                {{ $t("productServer.perPage", { count: 100 }) }}
              </option>
            </select>
          </div>
        </div>
      </div>
    </div>

    <!-- ===== 详情弹窗 ===== -->
    <div v-if="showModal" class="modal-overlay" @click.self="closeModal">
      <div class="modal-content">
        <div class="modal-header">
          <h3 class="modal-title">{{ $t("productServer.detailTitle") }}</h3>
          <button class="modal-close" @click="closeModal">✕</button>
        </div>

        <div class="modal-body" v-if="currentDetail">
          <!-- 基本信息 -->
          <div class="detail-section">
            <div class="detail-row">
              <span class="detail-label">{{ $t("productServer.region") }}</span>
              <span class="detail-value">
                <img
                  v-if="currentDetail.country_img"
                  :src="currentDetail.country_img"
                  class="detail-flag"
                  @error="handleImageError"
                />
                {{ $t("country." + currentDetail.country_id) }}
              </span>
            </div>
            <div class="detail-row">
              <span class="detail-label">{{
                $t("productServer.orderName")
              }}</span>
              <span class="detail-value">{{
                $t(currentDetail.server_code + ".s_model") || "-"
              }}</span>
            </div>
            <div class="detail-row">
              <span class="detail-label">{{
                $t("productServer.productCode")
              }}</span>
              <span class="detail-value">{{
                currentDetail.server_code || "-"
              }}</span>
            </div>
            <div class="detail-row">
              <span class="detail-label">{{
                $t("productServer.orderCode")
              }}</span>
              <span class="detail-value">{{ currentDetail.code || "-" }}</span>
            </div>
            <div class="detail-row">
              <span class="detail-label">{{ $t("productServer.status") }}</span>
              <span class="detail-value">
                <span
                  class="status-badge"
                  :class="getStatusClass(currentDetail)"
                >
                  {{ getStatusText(currentDetail) }}
                </span>
              </span>
            </div>
          </div>

          <!-- 交易信息 -->
          <div class="detail-section">
            <div class="detail-section-title">
              {{ $t("productServer.leaseInfo") }}
            </div>
            <div class="detail-grid">
              <div class="detail-grid-item">
                <span class="detail-label">{{
                  $t("productServer.leaseDate")
                }}</span>
                <span class="detail-value text-success">{{
                  currentDetail.create_time
                }}</span>
              </div>
              <div class="detail-grid-item">
                <span class="detail-label">{{ $t("productServer.rent") }}</span>
                <span class="detail-value"
                  >${{ formatNumber(currentDetail.total) }}</span
                >
              </div>
              <div class="detail-grid-item">
                <span class="detail-label">{{
                  $t("productServer.share")
                }}</span>
                <span class="detail-value"
                  >{{ currentDetail.share * 100 }}%</span
                >
              </div>
              <div class="detail-grid-item">
                <span class="detail-label">{{
                  $t("productServer.maintenanceFee")
                }}</span>
                <span class="detail-value">${{ currentDetail.fee }}</span>
              </div>
              <div class="detail-grid-item">
                <span class="detail-label">{{
                  $t("productServer.countdown")
                }}</span>
                <span class="detail-value"
                  >{{ currentDetail.end_day }}
                  {{ $t("productServer.day") }}</span
                >
              </div>
            </div>
          </div>

          <!-- 收益信息 -->
          <div class="detail-section">
            <div class="detail-section-title">
              {{ $t("productServer.profitInfo") }}
            </div>
            <div class="detail-grid">
              <div class="detail-grid-item">
                <span class="detail-label">{{
                  $t("productServer.totalIncome")
                }}</span>
                <span class="detail-value text-success"
                  >${{
                    formatNumber(
                      currentDetail.total_income +
                        currentDetail.income +
                        currentDetail.current_income || 0,
                    )
                  }}</span
                >
              </div>
              <div class="detail-grid-item">
                <span class="detail-label">{{
                  $t("productServer.estimatedLeaseIncome")
                }}</span>
                <span
                  class="detail-value"
                  :class="getRevenueClass(currentDetail.yg_income)"
                >
                  ${{ formatNumber(currentDetail.yg_income) }}
                </span>
              </div>
              <div class="detail-grid-item">
                <span class="detail-label">{{
                  $t("productServer.unsettledIncome")
                }}</span>
                <span
                  class="detail-value"
                  :class="getRevenueClass(currentDetail?.income)"
                >
                  ${{
                    formatNumber(
                      currentDetail.current_income + currentDetail.income || 0,
                    )
                  }}
                </span>
              </div>
              <div class="detail-grid-item">
                <span class="detail-label">{{
                  $t("productServer.settledIncome")
                }}</span>
                <span class="detail-value text-success">{{
                  formatNumber(currentDetail.total_income || 0)
                }}</span>
              </div>
              <div
                class="detail-grid-item"
                v-for="(i, n) in currentDetail?.phase"
                :key="i"
              >
                <div style="display: flex; gap: 5px; align-items: baseline">
                  <span class="detail-label"
                    >{{ $t("productServer.phase", { count: n + 1 }) }}:</span
                  >
                  <span style="color: #ff98009c; font-size: 12px"
                    >({{ $t("serverServer.serverover") }}：{{
                      i.end_time
                    }})</span
                  >
                </div>
                <span class="detail-value text-success">
                  ${{ getPhaseAmount(n) }}</span
                >
              </div>
              <div class="detail-grid-item">
                <span class="detail-label">{{
                  $t("productServer.currentPhase")
                }}</span>
                <span class="detail-value text-success">{{
                  $t("productServer.phase", {
                    count:
                      currentDetail?.phase?.status == 2
                        ? currentDetail?.phase?.sort
                        : 1,
                  })
                }}</span>
              </div>
            </div>
          </div>

          <!-- 其他信息 -->
          <div class="detail-section" v-if="currentDetail.remark">
            <div class="detail-section-title">
              {{ $t("productServer.remark") }}
            </div>
            <div class="detail-remark">{{ currentDetail.remark }}</div>
          </div>
        </div>

        <div class="modal-footer">
          <button class="btn-modal-close" @click="closeModal">
            {{ $t("productServer.close") }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { loadProductsLanguage } from "@/locales";
export default {
  name: "ProductList",
  data() {
    return {
      // 分页参数
      page: 1,
      size: 10,
      total: 0,

      // 数据
      productList: [],
      countryList: [],
      loading: false,

      // 筛选条件
      filters: {
        region: "",
        status: 1,
      },

      // 弹窗
      showModal: false,
      currentDetail: null,

      pollTimer: null, // 轮询定时器
    };
  },
  watch: {
    "$i18n.locale": function (newLang, oldLang) {
      console.log(`语言从 ${oldLang} 切换到 ${newLang}`);
      this.loadProductTranslations();
    },
  },
  computed: {
    totalPages() {
      return Math.ceil(this.total / this.size);
    },
    pageNumbers() {
      const pages = [];
      const total = this.totalPages;
      const current = this.page;

      if (total <= 7) {
        for (let i = 1; i <= total; i++) {
          pages.push(i);
        }
      } else {
        pages.push(1);
        if (current > 3) {
          pages.push("...");
        }
        for (
          let i = Math.max(2, current - 1);
          i <= Math.min(total - 1, current + 1);
          i++
        ) {
          pages.push(i);
        }
        if (current < total - 2) {
          pages.push("...");
        }
        pages.push(total);
      }
      return pages;
    },
  },
  created() {
    this.getCountryList();
    this.handleFilterChange();
  },
  // ===== 组件销毁前清除定时器 =====
  beforeDestroy() {
    this.stopPolling();
  },
  methods: {
    async loadProductTranslations() {
      const codes = this.productList.map((p) => p.server_code);
      await loadProductsLanguage(codes, {
        path: "server/",
      });
    },
    // ===== 获取国家列表 =====
    getCountryList() {
      this.$api.country
        .getCountryList()
        .then((res) => {
          if (res.code === 0) {
            this.countryList = res.data;
          }
        })
        .catch((error) => {
          console.error("获取国家列表失败:", error);
        });
    },

    // ===== 获取产品列表 =====
    getUserServerList(params = {}) {
      this.loading = true;

      const requestParams = {
        page: this.page,
        size: this.size,
        ...params,
      };

      this.$api.userServer
        .getUserServerList(requestParams)
        .then((res) => {
          if (res.code === 0) {
            this.productList = res.data.data || [];
            this.total = res.data.total || 0;
            this.page = res.data.current || 1;
            this.size = res.data.pageSize || 10;

            // ===== 新增：数据加载完成后启动轮询 =====
            this.startPolling();
            this.loadProductTranslations();
          } else {
            console.error("获取产品列表失败:", res.msg);
            this.productList = [];
            this.total = 0;
          }
        })
        .catch((error) => {
          console.error("接口请求异常:", error);
          this.productList = [];
          this.total = 0;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // ===== 启动轮询 =====
    startPolling() {
      this.stopPolling(); // 先清除旧的定时器
      if (this.productList.length === 0) return;

      // 立即执行一次
      this.pollIncomes();

      // 每5秒轮询一次
      this.pollTimer = setInterval(() => {
        this.pollIncomes();
      }, 5000);
    },

    // ===== 停止轮询 =====
    stopPolling() {
      if (this.pollTimer) {
        clearInterval(this.pollTimer);
        this.pollTimer = null;
      }
    },

    // ===== 轮询获取收益 =====
    pollIncomes() {
      // 收集当前列表中所有记录的 code
      const codes = this.productList.map((item) => item.code).filter(Boolean);
      if (codes.length === 0) return;

      this.$api.userServer
        .getIncome({ codes })
        .then((res) => {
          if (res.code === 0) {
            const incomeData = res.data || {};
            // 遍历更新每条记录
            this.productList.forEach((item, index) => {
              if (incomeData[item.code] !== undefined) {
                // 根据接口返回的数据结构更新，这里假设返回的是 { code: incomeValue }
                // 如果返回的是完整对象，按实际情况调整
                this.$set(this.productList, index, {
                  ...item,
                  current_income: incomeData[item.code],
                  // income: incomeData[item.code]?.income || item.income,
                  // 其他需要更新的字段...
                });
              }
            });
          }
        })
        .catch((error) => {
          console.error("轮询获取收益失败:", error);
        });
    },
    // ===== 打开详情弹窗 =====
    openDetailModal(item) {
      //this.stopPolling(); // 暂停轮询
      this.currentDetail = item;
      this.showModal = true;
      document.body.style.overflow = "hidden";
    },

    // ===== 关闭详情弹窗 =====
    closeModal() {
      this.showModal = false;
      this.currentDetail = null;
      document.body.style.overflow = "";
      //this.startPolling(); // 恢复轮询
    },

    getPhaseAmount(n) {
      console.log(n)
      let index = -1;
      for (let i = 0; i < this.currentDetail?.phase?.length; i++) {
        const phase = this.currentDetail?.phase?.[i];
        if (phase.status == 1) {
          index = i;
          break;
        }
      }
      if (n == index && index != -1) {
        return this.currentDetail?.current_income || 0;
      }

      return this.currentDetail?.phase?.[n]?.amount || 0;
    },
    // ===== 状态文字 =====
    getStatusText(item) {
      const statusMap = {
        0: this.$t("productServer.statusPending"),
        1: this.$t("productServer.statusActive"),
        2: this.$t("productServer.statusCompleted"),
        3: this.$t("productServer.statusFrozen"),
      };
      //新增一个条件
      const begin_time = this.$dayjs(item.begin_time);
      const now = this.$dayjs();
      // console.log("时间比较", now < begin_time, now, begin_time);
      if (now < begin_time) {
        return statusMap[0] || "";
      }

      return statusMap[item.status] || this.$t("productServer.statusUnknown");
    },

    // ===== 状态样式 =====
    getStatusClass(item) {
      const classMap = {
        0: "status-pending",
        1: "status-active",
        2: "status-completed",
        3: "status-canceled",
      };

      //新增一个条件
      const begin_time = this.$dayjs(item.begin_time);
      const now = this.$dayjs();
      if (now < begin_time) {
        return classMap[0] || "status-unknown";
      }

      return classMap[item.status] || "status-unknown";
    },

    // ===== 收益颜色 =====
    getRevenueClass(value) {
      if (!value || value === 0) return "text-secondary";
      return value > 0 ? "text-success" : "text-danger";
    },

    // ===== 数据格式化 =====
    formatNumber(value) {
      if (value === undefined || value === null || isNaN(value)) {
        return "0.00";
      }
      return Number(value).toFixed(2);
    },

    // ===== 筛选 =====
    handleFilterChange() {
      this.page = 1;
      this.stopPolling(); // 停止旧轮询
      const params = {};
      if (this.filters.region) {
        params.country_id = this.filters.region;
      }
      if (this.filters.status) {
        params.status = parseInt(this.filters.status);
      }
      this.getUserServerList(params);
    },

    resetFilters() {
      this.filters.region = "";
      this.filters.status = "";
      this.page = 1;
      this.stopPolling(); // 停止旧轮询
      this.getUserServerList();
    },

    // ===== 分页 =====
    changePage(page) {
      if (page < 1 || page > this.totalPages || page === this.page) return;
      this.page = page;
      this.stopPolling(); // 停止旧轮询
      const params = {};
      if (this.filters.region) {
        params.country_id = this.filters.region;
      }
      if (this.filters.status) {
        params.status = parseInt(this.filters.status);
      }
      this.getUserServerList(params);
    },

    // ===== 每页条数变化 =====
    handleSizeChange() {
      this.page = 1;
      this.stopPolling(); // 停止旧轮询
      const params = {};
      if (this.filters.region) {
        params.country_id = this.filters.region;
      }
      if (this.filters.status) {
        params.status = parseInt(this.filters.status);
      }
      this.getUserServerList(params);
    },

    // ===== 图片加载失败处理 =====
    handleImageError(e) {
      e.target.style.display = "none";
    },
  },
};
</script>

<style scoped>
/* ===== Tab导航 ===== */
.tab-nav {
  display: flex;
  gap: 32px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
  margin-bottom: 0;
}

.tab-nav-item {
  padding: 12px 4px 10px;
  font-size: 15px;
  color: rgba(255, 255, 255, 0.4);
  cursor: pointer;
  border-bottom: 2px solid transparent;
  transition: all 0.3s ease;
  font-weight: 500;
}

.tab-nav-item:hover {
  color: rgba(255, 255, 255, 0.7);
}

.tab-nav-item.active {
  color: #fff;
  border-bottom-color: #00b4ff;
}

/* ===== 筛选栏 ===== */
.filter-bar {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 16px 0;
  flex-wrap: wrap;
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
  margin-bottom: 16px;
}

.filter-group {
  display: flex;
  align-items: center;
  gap: 8px;
}

.filter-label {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.5);
  font-weight: 500;
  white-space: nowrap;
}

.filter-select {
  padding: 6px 32px 6px 12px;
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 6px;
  color: rgba(255, 255, 255, 0.85);
  font-size: 13px;
  outline: none;
  cursor: pointer;
  appearance: none;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='rgba(255,255,255,0.4)' d='M6 8L1 3h10z'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 10px center;
  transition: all 0.2s;
  min-width: 120px;
}

.filter-select:hover {
  background-color: rgba(255, 255, 255, 0.1);
}

.filter-select:focus {
  border-color: rgba(0, 180, 255, 0.5);
  box-shadow: 0 0 0 3px rgba(0, 180, 255, 0.1);
}

.filter-select option {
  background: #1a1a2e;
  color: #fff;
}

.btn-reset {
  padding: 6px 16px;
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 6px;
  color: rgba(255, 255, 255, 0.6);
  font-size: 13px;
  cursor: pointer;
  transition: all 0.2s;
  margin-left: auto;
}

.btn-reset:hover {
  background: rgba(255, 255, 255, 0.12);
  color: rgba(255, 255, 255, 0.85);
}

/* ===== 查看按钮 ===== */
.btn-view {
  padding: 4px 14px;
  background: rgba(0, 180, 255, 0.12);
  border: 1px solid rgba(0, 180, 255, 0.2);
  border-radius: 6px;
  color: #4fc3ff;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  font-family: inherit;
}

.btn-view:hover {
  background: rgba(0, 180, 255, 0.25);
  border-color: #00b4ff;
  box-shadow: 0 0 20px rgba(0, 180, 255, 0.1);
}

/* ===== 表格 ===== */
.product-table-wrap {
  overflow-x: auto;
}

.product-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
}

.product-table thead th {
  text-align: left;
  padding: 12px 10px;
  color: rgba(255, 255, 255, 0.4);
  font-weight: 500;
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
  white-space: nowrap;
}

.product-table tbody td {
  padding: 14px 10px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.04);
  color: rgba(255, 255, 255, 0.8);
  white-space: nowrap;
}

.product-table tbody tr:hover {
  background: rgba(255, 255, 255, 0.03);
}

.region-cell {
  display: flex;
  align-items: center;
  gap: 8px;
}

.region-flag-img {
  width: 24px;
  height: 18px;
  object-fit: cover;
  border-radius: 2px;
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.region-name {
  color: rgba(255, 255, 255, 0.85);
}

/* ===== 状态标签 ===== */
.status-badge {
  display: inline-block;
  padding: 2px 10px;
  border-radius: 10px;
  font-size: 12px;
  font-weight: 500;
  white-space: nowrap;
}

.status-pending {
  color: #ffd866;
  background: rgba(255, 216, 102, 0.1);
}

.status-active {
  background: rgba(0, 180, 255, 0.15);
  color: #4fc3ff;
}

.status-completed {
  background: rgba(0, 200, 150, 0.15);
  color: #4ade80;
}

.status-canceled {
  background: rgba(255, 82, 82, 0.15);
  color: #ff6b6b;
}

.status-unknown {
  background: rgba(255, 255, 255, 0.05);
  color: rgba(255, 255, 255, 0.4);
}

/* ===== 颜色工具 ===== */
.text-success {
  color: #4ade80;
}

.text-danger {
  color: #ff6b6b;
}

.text-secondary {
  color: rgba(255, 255, 255, 0.4);
}

/* ===== 加载状态 ===== */
.loading-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  color: rgba(255, 255, 255, 0.3);
}

.loading-spinner {
  width: 32px;
  height: 32px;
  border: 3px solid rgba(255, 255, 255, 0.1);
  border-top-color: #4fc3ff;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
  margin-bottom: 12px;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  color: rgba(255, 255, 255, 0.3);
}

.empty-icon {
  font-size: 48px;
  margin-bottom: 12px;
}

/* ===== 分页 ===== */
.pagination-wrap {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 20px 0 10px;
  border-top: 1px solid rgba(255, 255, 255, 0.06);
  margin-top: 16px;
  flex-wrap: wrap;
}

.pagination-info {
  color: rgba(255, 255, 255, 0.5);
  font-size: 13px;
  white-space: nowrap;
}

.pagination-buttons {
  display: flex;
  align-items: center;
  gap: 4px;
  flex-wrap: wrap;
}

.page-btn {
  padding: 6px 12px;
  min-width: 32px;
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 4px;
  color: rgba(255, 255, 255, 0.6);
  font-size: 13px;
  cursor: pointer;
  transition: all 0.2s;
  text-align: center;
}

.page-btn:hover:not(:disabled):not(.active) {
  background: rgba(255, 255, 255, 0.12);
  color: rgba(255, 255, 255, 0.85);
}

.page-btn:disabled {
  opacity: 0.3;
  cursor: not-allowed;
}

.page-btn.active {
  background: rgba(0, 180, 255, 0.2);
  border-color: rgba(0, 180, 255, 0.3);
  color: #4fc3ff;
}

.pagination-size {
  display: flex;
  align-items: center;
}

.size-select {
  padding: 6px 12px;
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 4px;
  color: rgba(255, 255, 255, 0.85);
  font-size: 13px;
  outline: none;
  cursor: pointer;
}

.size-select:focus {
  border-color: rgba(0, 180, 255, 0.3);
}

.size-select option {
  background: #1a1a2e;
  color: #fff;
}

/* ===== 弹窗样式 ===== */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  backdrop-filter: blur(8px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  animation: fadeIn 0.25s ease;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.modal-content {
  background: #141428;
  border-radius: 16px;
  max-width: 640px;
  width: 92%;
  max-height: 85vh;
  overflow-y: auto;
  border: 1px solid rgba(255, 255, 255, 0.08);
  box-shadow: 0 24px 80px rgba(0, 0, 0, 0.6);
  animation: slideUp 0.3s ease;
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(20px) scale(0.96);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px 16px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
}

.modal-title {
  font-size: 18px;
  font-weight: 700;
  color: #fff;
  margin: 0;
}

.modal-close {
  width: 32px;
  height: 32px;
  border: none;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.06);
  color: rgba(255, 255, 255, 0.5);
  font-size: 18px;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-close:hover {
  background: rgba(255, 255, 255, 0.12);
  color: #fff;
}

.modal-body {
  padding: 20px 24px;
}

.detail-section {
  margin-bottom: 20px;
}

.detail-section:last-child {
  margin-bottom: 0;
}

.detail-section-title {
  font-size: 13px;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.35);
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 12px;
  padding-bottom: 6px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.04);
}

.detail-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.03);
}

.detail-row:last-child {
  border-bottom: none;
}

.detail-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px 24px;
}

.detail-grid-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.03);
}

.detail-grid-item:last-child {
  border-bottom: none;
}

.detail-label {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.4);
}

.detail-value {
  font-size: 14px;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.85);
  display: flex;
  align-items: center;
  gap: 6px;
}

.detail-flag {
  width: 24px;
  height: 18px;
  object-fit: cover;
  border-radius: 2px;
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.detail-remark {
  padding: 12px 16px;
  background: rgba(255, 255, 255, 0.04);
  border-radius: 8px;
  color: rgba(255, 255, 255, 0.7);
  font-size: 14px;
  line-height: 1.6;
}

.modal-footer {
  padding: 16px 24px 20px;
  border-top: 1px solid rgba(255, 255, 255, 0.06);
  display: flex;
  justify-content: flex-end;
}

.btn-modal-close {
  padding: 8px 28px;
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  color: rgba(255, 255, 255, 0.6);
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  font-family: inherit;
}

.btn-modal-close:hover {
  background: rgba(255, 255, 255, 0.15);
  color: #fff;
}

/* ===== 滚动条美化 ===== */
.modal-content::-webkit-scrollbar {
  width: 4px;
}

.modal-content::-webkit-scrollbar-track {
  background: transparent;
}

.modal-content::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.15);
  border-radius: 4px;
}

.modal-content::-webkit-scrollbar-thumb:hover {
  background: rgba(255, 255, 255, 0.25);
}

/* ===== 响应式 ===== */
@media (max-width: 768px) {
  .filter-bar {
    flex-direction: column;
    align-items: stretch;
    gap: 10px;
  }

  .filter-group {
    width: 100%;
  }

  .filter-select {
    flex: 1;
    min-width: unset;
  }

  .btn-reset {
    margin-left: 0;
    width: 100%;
  }

  .product-table thead th,
  .product-table tbody td {
    padding: 10px 6px;
    font-size: 12px;
  }

  .region-flag-img {
    width: 20px;
    height: 15px;
  }

  .pagination-wrap {
    flex-direction: column;
    align-items: center;
    gap: 12px;
  }

  .pagination-info {
    font-size: 12px;
  }

  .page-btn {
    padding: 4px 10px;
    font-size: 12px;
    min-width: 28px;
  }

  .modal-content {
    width: 96%;
    max-height: 90vh;
  }

  .detail-grid {
    grid-template-columns: 1fr;
  }

  .modal-body {
    padding: 16px;
  }

  .modal-header {
    padding: 16px 16px 12px;
  }
}

@media (max-width: 480px) {
  .tab-nav {
    gap: 16px;
    overflow-x: auto;
  }

  .tab-nav-item {
    font-size: 13px;
    white-space: nowrap;
    padding: 10px 2px 8px;
  }

  .product-table thead th,
  .product-table tbody td {
    padding: 8px 4px;
    font-size: 11px;
  }

  .btn-view {
    padding: 2px 10px;
    font-size: 11px;
  }

  .modal-content {
    border-radius: 12px;
  }
}
</style>
